import React from 'react'
import { Link } from 'react-router-dom'
import * as ROUTES from '../../constants/routes'
import { Paper, Grid, Table, TableHead, TableBody, TableRow, TableCell, Button } from '@material-ui/core'
import { withFirebase } from '../Firebase'

class Invoice extends React.Component {

    state = {
        order: 'silviano'
    }

    componentDidMount() {
        this.props.firebase.getCollection('products', products => {
            this.setState({ products })
        })
        this.props.firebase.getCollection('orders/silviano/cart', items => {
            this.setState({ items })
        })
        this.props.firebase.getCollection('orders/silviano/receipt', receipt => {
            const payments = Object.values(receipt)
            this.setState({ payments })
        })
    }

    render() {

        var orderTotal = 0
        var receiptTotal = 0

        const receiptRows = () => {
            if (!this.state.payments) return
            return this.state.payments.map((payment, i) => {
                receiptTotal += payment.amount
                return (
                    <TableRow key={i}>
                        <TableCell>{(new Date(payment.date.seconds * 1000)).toLocaleDateString()}</TableCell>
                        <TableCell>{payment.paymentNumber}/{payment.totalPayments}</TableCell>
                        <TableCell>{payment.status}</TableCell>
                        <TableCell>{payment.payer}</TableCell>
                        <TableCell>${payment.amount}</TableCell>
                    </TableRow>
                )
            })
        }

        const fractalName = (
            <Grid item xs={12} sm={6}>
                <h3>Fractal Strategies</h3>
                <p>Creative Software Solutions</p>
            </Grid>
        )

        const fractalInfo = (
            <Grid item xs={12} sm={6}>
                <br /><span style={{ border: '2px black solid', padding: '10px' }}>INVOICE</span><br /><br />
                <span>3806 W Belden Ave</span><br />
                <span>Chicago, IL 60647</span><br />
                <span>630-936-8882</span><br />
                <span>fractalstrategies.com</span>
            </Grid>
        )

        const clientInfo = (
            <Grid item xs={12} sm={6}>
                <span>To:</span>&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ fontSize: '1.25em' }}>Alpha Quality Inc</span><br /><br />
                <span>290 N Cedar Ave</span><br />
                <span>Wood Dale, IL 60191</span><br />
                <span>630-570-1398</span><br />
                <span>www.alphaqualityinc.com</span>
            </Grid>
        )

        const invoiceInfo = (
            <Grid item xs={12} sm={6}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>Invoice #</TableCell>
                            <TableCell>1025</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Invoice Date</TableCell>
                            <TableCell>02/20/2019</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>First Meeting</TableCell>
                            <TableCell>02/20/2019</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Work Start</TableCell>
                            <TableCell>02/20/2019</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Work End</TableCell>
                            <TableCell>03/15/2019</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Warrantee End</TableCell>
                            <TableCell>03/25/2019</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Grid>
        )

        const tr = (item, sup) => {
            if (!this.state.items) return
            const quantity = this.state.items[item].quantity
            const price = this.state.products[item].price
            const rowTotal = quantity * price
            orderTotal += rowTotal
            return (
                <TableRow>
                    <TableCell>{quantity}</TableCell>
                    {sup ?
                        <TableCell>{this.state.products[item].name}<sup>{sup}</sup> {this.state.products[item].subtext}</TableCell> :
                        <TableCell>{this.state.products[item].name} {this.state.products[item].subtext}</TableCell>
                    }
                    <TableCell>${price} / {this.state.products[item].unit}</TableCell>
                    <TableCell>${rowTotal}</TableCell>
                </TableRow>
            )
        }

        const orderInfo = (
            <Grid item xs={12}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Item / Service</TableCell>
                            <TableCell>Unit Price</TableCell>
                            <TableCell>Total</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tr('domain', 1)}
                        {tr('app', 2)}
                        {tr('page')}
                        {tr('form')}
                        {tr('database', 3)}
                        {tr('table')}
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell><b>Total</b></TableCell>
                            <TableCell></TableCell>
                            <TableCell><b>${orderTotal}</b></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Grid>
        )

        const receiptInfo = (
            <Grid item xs={12}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>#</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Payer</TableCell>
                            <TableCell>Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {receiptRows()}
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell><b>Total Payments</b></TableCell>
                            <TableCell></TableCell>
                            <TableCell><b>${receiptTotal}</b></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell><b>Remaining Balance</b></TableCell>
                            <TableCell></TableCell>
                            <TableCell><b>${orderTotal - receiptTotal}</b></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Grid>
        )

        const notesInfo = (
            <Grid item xs={12}>
                <div style={{ fontSize: '0.75em', textAlign: 'left' }}>
                    <ol>
                        <li>{this.state.products ? this.state.products.domain.notes : ''}</li>
                        <li>{this.state.products ? this.state.products.app.notes : ''}</li>
                        <li>{this.state.products ? this.state.products.database.notes : ''}</li>
                    </ol>
                </div>
            </Grid>
        )

        const buttons = (
            <Grid container spacing={16} justify='center'>
                <Grid item xs={2}>
                    <Button variant='contained' color='primary' component={Link} to={ROUTES.HOME}>
                        back
                    </Button>
                </Grid>
                <Grid item xs={2}>
                    <Button variant='contained' color='primary' component={Link} to={ROUTES.PRICING}>
                        pricing
                    </Button>
                </Grid>
            </Grid>
        )

        return (
            <div style={{ minWidth: '550px' }}>
                <h1>Invoice</h1>
                <Paper style={{ maxWidth: '700px', margin: 'auto', padding: '40px' }}>
                    <Grid container spacing={16} justify='space-around' alignItems='center'>
                        {fractalName}
                        {fractalInfo}
                        {clientInfo}
                        {invoiceInfo}
                        <Grid item xs={12}>
                            <h3>Order</h3>
                        </Grid>
                        {orderInfo}
                        <Grid item xs={12}>
                            <h3>Receipt</h3>
                        </Grid>
                        {receiptInfo}
                        <Grid item xs={12}>
                            <h5>Notes</h5>
                        </Grid>
                        {notesInfo}
                    </Grid>
                </Paper>
                <br /><br />
                {buttons}
            </div>
        )

    }

}

export default withFirebase(Invoice)
